<template>
  <h1 class="mt-3 mb-3">採購專業人員基礎證照
    <span class="d-none d-md-inline">|</span> <br class="d-md-none"/>
    關鍵字查詢
  </h1>
  <div class="mb-3 row justify-content-center queryInput">
    <label for="keyword" class="col-sm-1 col-form-label">關鍵字</label>
    <div class="col-sm-12 px-4 col-md-6">
      <input type="text" class="form-control" id="keyword" v-model="queryKeyword">
    </div>
  </div>

  <div class="search-result">比對結果： 政府採購法 {{ filterLaws('GPL').length }}
    / 施行細則 {{ filterLaws('GPLD').length }}
    / 題目 {{ filterQues.length }}</div>

  <div v-if="filterLaws('GPL').length > 0">
    <h2>政府採購法</h2>

    <div v-for="law in filterLaws('GPL')" v-bind:key="law">
      <div class="question-block">
        <div class="law-info">
          <span>
            {{ law.lawChapter }} | §{{ law.lawNo }}
          </span>
        </div>

        <div v-html="lawFormat(law.lawContent)">
        </div>
      </div>
    </div>
  </div>

  <div v-if="filterLaws('GPLD').length > 0">
    <h2>政府採購法施行細則</h2>

    <div v-for="law in filterLaws('GPLD')" v-bind:key="law">
      <div class="question-block">
        <div class="law-info">
          <span>
            {{ law.lawChapter }} | §{{ law.lawNo }}
          </span>
        </div>

        <div v-html="lawFormat(law.lawContent)">
        </div>
      </div>
    </div>
  </div>

  <hr/>

  <div class="procurement-questions">
    <div v-for="quesObject in filterQues" v-bind:key="quesObject">
      <div class="question-block">
        <div v-html="smartString(quesObject.question)"></div>

        <div class="question-ref">
          {{ quesObject.category }} | {{quesObject.qno}}
          <span v-if="quesObject.law">
            |
            <a :href="getRefLawLink(quesObject.law)" target="_blank">
            {{ quesObject.law }}
            </a>
          </span>
        </div>
      </div>

      <div class="answer-block">
        <ol>
        <li v-for="(a, index) in quesObject.ansPool" :key="a" class="answer-option"
          v-bind:class="{ 'correct-answer': index === quesObject.ansIndex}">
          {{a}}
        </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import quesbank from '@/data/quesbank.json';
import GPL from '@/data/GPL.json';
import GPLD from '@/data/GPLD.json';
import GPLRelated from '@/data/relatedLaws.json';

export default {
  name: 'Query',
  data() {
    return {
      queryKeyword: '底價',
      showAns: false,
      clickAns: -1,
      absoluteQno: this.$route.params.id,
      quesObj: null,
      roundQues: [],
      roundFinish: [],
      corrects: [],
      wrongs: new Set(),
      documents: [],
      excludeTF: true,
    };
  },
  components: {

  },
  beforeMount() {
  },
  mounted() {
    window.addEventListener('keypress', (e) => {
      const inputKey = e.key.toString();
      if (inputKey === 'Enter' || inputKey === 'j' || inputKey === 'J') {
        this.getQues();
      }
    });
  },
  watch: {
  },
  computed: {
    filterQues() {
      if (this.queryKeyword === '') {
        return [];
      }
      return Object.values(quesbank).filter(
        (e) => e.question.includes(this.queryKeyword)
              || e.ansPool.some((ans) => ans.includes(this.queryKeyword))
              || e.law.includes(this.queryKeyword),
      );
    },
  },
  methods: {
    getRefLawLink(law) {
      const matchNumber = law.match(/\d+/g);
      if (matchNumber !== null) {
        return `https://law.moj.gov.tw/LawClass/LawSingle.aspx?pcode=A0030057&flno=${matchNumber[0]}`;
      }
      return 'https://law.moj.gov.tw/LawClass/LawAll.aspx?pcode=A0030057';
    },
    isCorrect(index) {
      return index === this.quesObj.ansIndex && this.showAns === true;
    },
    isWrong(index) {
      return index !== this.quesObj.ansIndex && this.showAns === true && index === this.clickAns;
    },
    filterLaws(lawName) {
      if (this.queryKeyword === '') {
        return [];
      }
      const lawUsage = lawName === 'GPL' ? GPL : GPLD;

      if (lawName === 'GPLD') {
        const relatedLawsArray = GPLRelated[this.queryKeyword] === undefined
          ? [] : GPLRelated[this.queryKeyword].map((e) => String(e));

        return Object.values(lawUsage).filter(
          (law) => law.lawContent.includes(this.queryKeyword)
            || relatedLawsArray.includes(law.lawNo),
        );
      }
      return Object.values(lawUsage).filter(
        (law) => law.lawContent.includes(this.queryKeyword)
          || law.lawNo === this.queryKeyword,
      );
    },
    smartString(quesString) {
      const regexp = /採購法第(\d{1,3})條/i;
      const match = quesString.match(regexp);

      if (match !== null) {
        const [keywords, lawNo] = match;

        const href = `https://law.moj.gov.tw/LawClass/LawSingle.aspx?pcode=A0030057&flno=${lawNo}`;
        const replaced = `<a href='${href}' target='_blank'>${keywords}</a>`;

        return quesString.replace(keywords, replaced);
      }
      return quesString;
    },
    lawFormat(lawString) {
      return lawString
        .replaceAll('：\n', '：<br/>')
        .replaceAll('。\n', '。<br/>')
        .replaceAll('\n', '');
    },
  },
};
</script>

<style scoped lang="scss">
$block-width : 62%;
$desktop: 'min-width: 1024px';
$pad: 'max-width: 1024px';
$mobile: 'max-width: 600px';

@mixin desktop{
  @media($desktop){
    @content;
  }
}
@mixin pad{
  @media($pad){
    @content;
  }
}
@mixin mobile{
  @media($mobile){
    @content;
  }
}

.correct-answer{
  color: green;
  font-weight: 900;
}

.wrong-answer{
  color: red;
  text-decoration: line-through;
}

.question-block{
  border: 2px solid teal;
  color: teal;
  border-radius: 3px;
  width: $block-width;
  display: block;
  margin: 20px auto;
  padding: 15px 15px;
  text-align: justify;
  font-size: 1.5rem;
  letter-spacing: 1px;
  @include pad{
    width: 95%;
  }
  @include mobile{
    width: 95%;
    font-size: 1rem;
  }
}

.answer-block{
  background-color: beige;
  border: 2px darksalmon dashed;
  color: black;
  padding: 5px;
  font-size: 1.5rem;
  width: $block-width;
  text-align: left;
  display: inline-block;
  margin-bottom: 10px;
  border-radius: 3px;
  @include pad{
    width: 95%;
  }
  @include mobile{
    width: 95%;
    font-size: 1rem;
  }
}

.answer-btns{
  margin-top: 20px;
  @include mobile{
    margin-top: 5px;
  }
}

.answer-btn{
  font-size: 1.25rem;
  padding: .5rem 1rem;
  @include mobile{
    margin-right: 25px !important;
    margin-left: 25px !important;
    font-size: 1rem;
    padding: .5rem 1rem;
  }
}

.law-info{
  font-size: 1.25rem;
  color: black;
  text-align: left;
  margin-bottom: 10px;

  @include mobile{
    font-size: 0.8rem;
  }
}

.question-ref{
  font-size: 1.25rem;
  color: black;
  text-align: right;
  margin-bottom: 10px;

  @include mobile{
    font-size: 0.8rem;
  }
}

.queryInput{
  font-size: 1.25rem;
}

.search-result{
  font-size: 1.25rem;
  font-weight: 800;
  margin-bottom: 10px;
}
</style>
